import React, { useState, useEffect } from 'react';
import { Icon } from 'react-icons-kit'
import { upload } from 'react-icons-kit/fa/upload'
import { ic_delete_forever } from 'react-icons-kit/md/ic_delete_forever'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import $ from 'jquery'

import api from '../../services/api'

import './index.css';

const swal = withReactContent(Swal)

function FrImageEdit(props) {
    const [imagePath, setImagePath] = useState(api.noImageUrl);
    const [imageFile, setImageFile] = useState({})

    useEffect(() => {
        const fetchImage = async () => {
            setImagePath(await api.getImage(props.regName, props.pk, props.image))
        }

        fetchImage()
    }, [props.image])

    const selectFile = (e) => {
        e.preventDefault();
        $('#html_btn_foto'+(props.fieldName ? '_'+props.fieldName : '')).click();

    }

    const handleSelectedFile = (e) => {
        let file = e.target.files[0];
        console.log(file)
        if (file) {
            setImageFile(file)
        }
    }

    useEffect(() => {
        if (imageFile.name) {
            swal.fire({
                title: 'ATENÇÃO',
                text: "Deseja alterar a foto ?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    let formData = new FormData();
                    formData.append('file', imageFile, imageFile.name)
                    api.post('/' + props.regName + '/postImage/' + props.pk, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(r => {
                        if (r.status === 200) {
                            api.post('/' + props.regName + '/changeImage'+(props.fieldName ? '/'+props.fieldName : '')+'/'+ props.pk + '/' + imageFile.name).then(r => {
                                if (r.status === 200) {
                                    swal.fire({
                                        title: 'Foto Alterada!',
                                        text: "A foto foi alterada com sucesso!",
                                        icon: 'success',
                                    }).then((result) => {
                                        if (result.value) {
                                            props.onImageChange(imageFile.name, (props.fieldName ? props.fieldName : null))
                                        }
                                    })
                                } else {
                                    swal.fire({
                                        title: 'Erro!',
                                        text: "A foto não pôde ser alterada!",
                                        icon: 'error',
                                    })
                                }
                            })
                        } else {
                            swal.fire({
                                title: 'Erro!',
                                text: "Ocorreu um erro no upload da foto!",
                                icon: 'error',
                            })
                        }
                    })
                }
            })
        }
    }, [imageFile])

    const clearImage = (e) => {
        e.preventDefault();
        swal.fire({
            title: 'ATENÇÃO',
            text: "Deseja remover a foto?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                api.post('/' + props.regName + '/deleteImage'+(props.fieldName ? '/'+props.fieldName : '') + '/'+props.pk).then(r => {
                    if (r.status === 200) {
                        swal.fire({
                            title: 'Foto Excluída',
                            text: "A foto foi excluída com sucesso!",
                            icon: 'success',
                        }).then((result) => {
                            if (result.value) {
                                props.onImageChange(null,  (props.fieldName ? props.fieldName : null))
                            }
                        })
                    } else {
                        swal.fire({
                            title: 'Erro!',
                            text: "A foto não foi excluída!",
                            icon: 'warning',
                        })
                    }
                })
            }
        })
    }

    return (
        <div className="FrImageEdit" style={{ display: props.visible ? 'flex' : 'none' }}>
            <div className="FrImageContainer">
                <img src={imagePath} onClick={selectFile} />


            </div>
            <div className="FrImageOptions">
                <input
                    type="file"
                    name="arquivo"
                    id={"html_btn_foto"+(props.fieldName ? '_'+props.fieldName : '')}
                    accept=".png, .jpg, .jpeg"
                    onChange={handleSelectedFile}

                />
                <button type="file" onClick={selectFile}>
                    <Icon icon={upload} size={20} />
                </button>
                <br />
                <button onClick={clearImage}>
                    <Icon icon={ic_delete_forever} size={20} />
                </button>
            </div>
        </div>
    )
}

export default FrImageEdit;